import { InteractionEventType, } from '@debbie/common/dist/interactions/events/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../../../theme.js';
import Alert from '../../../Alert.js';
import Col from '../../../Grid/Col.js';
import Row from '../../../Grid/Row.js';
import CheckCircle from '../../../Icons/CheckCircle.js';
import Shield from '../../../Icons/Shield.js';
import XCircle from '../../../Icons/XCircle.js';
import Well from '../../../Well.js';
import { Box } from '../Helpers.js';
import CommonEvent from './CommonEvents.js';
const EBoksEventCmp = (props) => {
    switch (props.event.type) {
        case InteractionEventType.Delivered:
            return React.createElement(DeliveredEvent, { event: props.event });
        case InteractionEventType.Failed:
            return React.createElement(FailedEvent, { event: props.event });
        default:
            return React.createElement(CommonEvent, { event: props.event });
    }
};
const DeliveredEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Delivered) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(CheckCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Delivered]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.deliveredAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.eBoksMessageId, body: event.data.messageId || 'N/A' }))));
};
const FailedEvent = (props) => {
    const { event } = props;
    const lang = useSelector((s) => s.lang);
    if (event.type !== InteractionEventType.Failed) {
        throw 'Invalid event type';
    }
    return (React.createElement(Well, { style: { marginBottom: `${THEME.GRID_SPACING}px` } },
        React.createElement(Row, null,
            React.createElement(Col, { width: "12" },
                React.createElement("h3", { style: { color: THEME.COLOR_ACCENT } },
                    React.createElement(XCircle, { style: {
                            margin: '0.15em 0 -0.15em',
                        } }),
                    ' ',
                    lang.interactionEventTypes[InteractionEventType.Failed]),
                React.createElement(Alert, { size: "small", style: {
                        backgroundColor: THEME.COLOR_SECONDARY,
                        color: THEME.COLOR_ACCENT,
                    }, message: `Event id: ${event.id}` }))),
        React.createElement(Row, null,
            React.createElement(Box, { header: lang.interactions.failedAt, body: React.createElement(React.Fragment, null,
                    React.createElement(Shield, { style: {
                            margin: '0.15em 0 -0.15em',
                            color: THEME.COLOR_ACCENT,
                        } }),
                    ' ',
                    moment(event.createdAt).format(THEME.DATE_FORMAT_LONG)) }),
            React.createElement(Box, { header: lang.interactions.reason, body: event.data.errorText || 'N/A' }))));
};
export default EBoksEventCmp;
//# sourceMappingURL=EBoks.js.map